<div id="clientDesktopView">
  <h3>Cliente</h3>
  <div>
    <div class="wrapperG5">
      <div class="controlWrapper">
        <label>Tipo de persona</label>
        <span class="value">{{ clientsService.getPersonType(customer?.personType) }}</span>
      </div>
      @if(rfc) {
      <div class="controlWrapper">
        <label>RFC</label>
        <span class="value">{{ rfc }}</span>
      </div>
      } @if(lastName) {
      <div class="controlWrapper">
        <label>Apellido paterno</label>
        <span class="value">{{ lastName }}</span>
      </div>
      } @if(personType === 'NATURAL_PERSON') {
      <div class="controlWrapper">
        <label>Apellido materno</label>
        <span class="value">{{ mothersLastName }}</span>
      </div>
      } @if(name) {
      <div class="controlWrapper">
        <label>Nombre</label>
        <span class="value">{{ name }}</span>
      </div>
      }
      <!-- <div class="controlWrapper">
        <label>Segundo nombre</label>
        <span class="value">{{ customer?.secondName }}</span>
      </div> -->
      @if (featureLoyaltyFeriaQuotation) {
      <div class="controlWrapper">
        <label>Cliente de feria</label>
        <span class="value">{{ customerFeriaReadonlyYesNo() }}</span>
      </div>
      }
    </div>
  </div>
</div>
